import { Flex, Space, Table, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import backendApi from '../api/backendApi'
import { DigitalBill, GetDigitalBillsRequest } from '../interfaces/AppInterfaces'
import Link from 'antd/es/typography/Link'

const DigitalEmiterBillsPage = () => {
  
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [ digitalBills, setDigitalBills] = useState<DigitalBill[]>()

    const getDigitalBills = async () => {
        const getDigitalBillsRequest = await backendApi.get<GetDigitalBillsRequest>('/getEmitersBills')
        setDigitalBills(getDigitalBillsRequest.data.data[0])
        setIsLoading(false)
    }
    
    const columns =[
        {
            title: 'Numero de Control',
            dataIndex: 'control_num',
            key: 'control_num',
        },
        {
            title: 'Numero del Documento',
            dataIndex: 'doc_num',
            key: 'doc_num',
        },
        {
            title: 'Nombre del Cliente',
            dataIndex: 'client_full_name',
            key: 'client_full_name',
        },
        {
            title: 'Email del Cliente',
            dataIndex: 'client_email',
            key: 'client_email',
        },
        {
            title: 'Total de Factura',
            dataIndex: 'total_w_taxes',
            key: 'total_w_taxes',
        },
        {
            title: 'Total de Impuesto',
            dataIndex: 'total_tax',
            key: 'total_tax',
        },
        {
            title: 'Ver',
            key: 'watch',
            //@ts-ignore
            render: (_, record) => (
                <Space size="middle">
                  <Link onClick={()=>downloadBillXML(record.id)}>XML</Link>
                  <Link onClick={()=>getBillPDF(record.id)}>PDF</Link>
                </Space>
              ),
        },
    ]

    const downloadBillXML = async (id:string) => {
      
        const response = await backendApi.get("getDigitalBillXML/"+id,{responseType: 'blob'})
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        const fileName = 'FACT_'+id+'.xml';
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
    }

    const getBillPDF = async (id:string)=>{
        const response = await backendApi.get("getDigitalBillPDF/"+id)
        window.open(response.data.data[0]); 
    }

    useEffect(() => {
        getDigitalBills()
    }, [])
    
    return (
    <Flex justify="center" vertical gap="middle">
      <Typography.Title>Facturas</Typography.Title>  
        <Table columns ={columns} dataSource={digitalBills} scroll={{ x: 1}} loading={isLoading}/>
    </Flex>
  )
}

export default DigitalEmiterBillsPage
